module.exports = __webpack_public_path__ + "static/media/protocol_2025_03_25.10e4dff1.htm";